export function addressParse(address) {
  var splitedAddress = address.split(",")[0];
  // const [first, ...rest] = (splitedAddress || "").split(" ");
  // if (first && rest && rest.length > 0) {
  //   if (first.match(/\d*/) || first.match(/\d*\/\d*/)) {
  //     //match 100 Franklin Street or 2/1 Franklin Street
  //     return {
  //       unit: first,
  //       street: rest.join(" "),
  //     };
  //   }
  // }
  const unit = "",
    street = splitedAddress;
  return {
    unit,
    street,
  };
}
